import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import bells from "../../assets/svg/bells.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/navigation-prev.svg";
import { ReactComponent as SuccessIcon } from "../../assets/svg/success.svg";
import RoomImage from "../../assets/png/room-image.png";
import Select from "react-select";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "react-day-picker/dist/style.css";
import { apiCall, apiCallAdmin } from "../../services/api-service";
import { Form, Button, Container, InputGroup } from "react-bootstrap";
import "./input-style.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LoaderModal from "../common/Loader.js";
import moment from "moment";
import { ReactComponent as RepeatIcon } from "../../assets/svg/repeate.svg";
import { getRemainderDefaultApi, getRemainderList } from "./discover-services.js";
import SearchWithFreeTextAPI from "../searchbox/searchbox-free-text.js";
import { useGlobal } from "../../GlobalContext.js";

export default function CreateBooking() {
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const location = useLocation();
  const { id, date, formatted_date, selected_slot, selected_slot_from, selected_slot_to, repeat_booking, repeat } = location.state || {};

  const [selectedRemainderOptions, setSelectedRemainderOptions] = useState([]);
  const [remainderOptions, setRemainderOptions] = useState([]);
  const [meetingRoomDetails, setMeetingRoom] = useState({});
  const [isShowError, setShowError] = useState(false);
  const [email, setEmail] = useState("");
  const [isProceed, setProceed] = useState(false);
  const [isConfirmBooking, setConfirmBooking] = useState(false);

  const [titleInputValue, setTitleInputValue] = useState("");
  const [companyInputValue, setCompanyInputValue] = useState("");
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");

  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [inviteEmails, setInviteEmail] = useState([]);

  useEffect(() => {
    getRemainders();
    fetchOptions();
  }, []);

  const getEmail = async () => {
    setLoading(true);

    try {
      const response = await apiCallAdmin("get", "profile");

      console.log("Email:", response.data.user.email);
      setEmail(response.data.user.email);
    } catch (err) {
      console.error("Error fetching email:", err);
      setError("Failed to fetch email. Try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedMenu("Discover");
    getEmail();
  }, []);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiCall("get", `room/${id}`);

      if (response.data.success === true) {
        console.log("booking:", response.data.room);
        setMeetingRoom(response.data.room);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const submitBookingRoom = async () => {
    setLoading(true);
    try {
      console.log("get_slots api called");
      const data = {
        title: titleInputValue,
        company_name: companyInputValue,
        description: descriptionInputValue,
        date: date,
        room_id: id.toString(),
        from: selected_slot_from,
        to: selected_slot_to,
        emails: inviteEmails,
        repeat_booking: false,
        reminders: selectedRemainderOptions.map((item) => item.value),
      };

      const response = await apiCall("post", "booking", data);
      if (response?.data?.success === true) {
        setConfirmBooking(true);
      } else {
        setError(response?.data?.message || "Failed to confirm booking. Try again.");
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  const repeatRoomBooking = async () => {
    setLoading(true);
    try {
      console.log("get_slots api called");
      const data = {
        title: titleInputValue,
        company_name: companyInputValue,
        description: descriptionInputValue,
        date: date,
        room_id: id.toString(),
        from: repeat.from,
        to: repeat.to,
        emails: inviteEmails,
        repeat_booking: true,
        repeat: repeat.repeat,
        reminders: selectedRemainderOptions.map((item) => item.value),
      };

      const response = await apiCall("post", "repeat_booking", data);
      if (response?.data?.success === true) {
        setConfirmBooking(true);
      } else {
        setError(response?.data?.message || "Failed to confirm booking. Try again.");
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  const [emailSearch, setEmailSearch] = useState("");

  const handleEmailDropdownChange = (option) => {
    setEmailSearch(option.value);
  };
  const handleEmailOnChange = (term) => {
    setEmailSearch(term);
  };
  function commonFormatDate(inputDate, formatString) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
        return moment(inputDate).format(formatString);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
  const convertTo12HourFormat = (time) => {
    let [hours, minutes] = time.split(":");
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${period}`;
  };
  const repeatSentence = () => {
    if (repeat.repeat.recurrence_type === "daily") {
      if (repeat.repeat.repeat_on.week_days_only === true) {
        return "The booking will repeat week days from " + commonFormatDate(repeat.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeat.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeat.from) + " and " + convertTo12HourFormat(repeat.to) + ".";
      }
      return "The booking will repeat every " + repeat.repeat.repeat + " day(s) once from " + commonFormatDate(repeat.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeat.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeat.from) + " and " + convertTo12HourFormat(repeat.to) + ".";
    } else if (repeat.repeat.recurrence_type === "weekly") {
      return "The meeting will repeat every " + repeat.repeat.repeat + " week(s) once from " + repeat.repeat.repeat_on.days_of_week.join(",") + " from " + commonFormatDate(repeat.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeat.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeat.from) + " and " + convertTo12HourFormat(repeat.to) + "";
    } else if (repeat.repeat.recurrence_type === "monthly_fixed") {
      return "The meeting will repeat on the " + repeat.repeat.day_of_month + " of every " + repeat.repeat.repeat + " month(s) once from " + commonFormatDate(repeat.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeat.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeat.from) + " and " + convertTo12HourFormat(repeat.to) + "";
    } else if (repeat.repeat.recurrence_type === "monthly_relative") {
      return "The meeting will repeat on the " + repeat.repeat.repeat_on.position + " " + repeat.repeat.repeat_on.day + " of every " + repeat.repeat.repeat + " month(s) once from " + commonFormatDate(repeat.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeat.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeat.from) + " and " + convertTo12HourFormat(repeat.to) + "";
    } else {
      return "";
    }
  };

  const getRemainders = async () => {
    try {
      const result = await getRemainderList(); // Wait for API response
      if (result.success === true) {
        setRemainderOptions(result.suggestionlist);
        getRemainderDefualt();
      }
      // Update state
    } catch (error) {
      console.error("Error adding item:", error);
    }
    console.log("Successfully called");
  };
  const getRemainderDefualt = async () => {
    try {
      const result = await getRemainderDefaultApi(); // Wait for API response
      if (result.success === true) {
        console.log(result);
        setSelectedRemainderOptions(result.suggestionlist);
      }
      // Update state
    } catch (error) {
      console.error("Error adding item:", error);
    }
    console.log("Successfully called");
  };

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {/*  <Header selectedTab={'Discover'} /> */}
      <Row
        className="flex-wrap px-3"
        style={{
          height: "calc(100vh - 68px)",
          overflow: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          justifyContent: "center",
        }}>
        <Col xl={8} style={{ padding: "16px", justifyContent: "center" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}>
            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1e1e1e" }}>Discover</div>
            &nbsp;&nbsp; <ArrowNextIcon />
            &nbsp;&nbsp;
            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1e1e1e" }}>{meetingRoomDetails["name"] ?? ""}</div>
            &nbsp;&nbsp; <ArrowNextIcon />
            &nbsp;&nbsp;
            <div style={{ fontSize: "13px", fontWeight: "500", color: "#842234" }}>Meeting details</div>
          </div>
          {(!isProceed || !isConfirmBooking) && <div style={{ fontSize: "24px", fontWeight: "700", color: "#1E1E1E" }}>Few steps ahead to book your room!</div>}
          {(!isProceed || !isConfirmBooking) && (
            <div
              style={{
                padding: "16px",
                marginTop: "16px",
                borderRadius: "24px",
                background: "#ffffff",
              }}>
              <div style={{ display: "flex" }}>
                <img src={RoomImage} alt="room" style={{ width: "36px", height: "36px", borderRadius: "6px" }} />
                <div style={{ marginLeft: "16px" }}>
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      color: "#1E1E1E",
                    }}>
                    {meetingRoomDetails["name"] ?? ""}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                    }}>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#842234",
                      }}>
                      {meetingRoomDetails["capacity"] ?? "0"} Seater
                    </div>{" "}
                    &nbsp;&nbsp;{" "}
                    <div
                      style={{
                        width: "3px",
                        height: "3px",
                        backgroundColor: "#D9D9D9",
                      }}></div>
                    &nbsp;&nbsp;
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#81878C",
                      }}>
                      {meetingRoomDetails["category"] ?? ""}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "400",
                    color: "#1E1E1E",
                  }}>
                  Slot selected on &nbsp;
                </div>
                {!(repeat_booking != null && repeat_booking === true) && (
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      color: "#842234",
                    }}>
                    {formatted_date}
                  </div>
                )}
                {repeat_booking != null && repeat_booking === true && (
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      color: "#842234",
                    }}>
                    {commonFormatDate(repeat.repeat.start_date, "ddd DD MMM YYYY")} - {commonFormatDate(repeat.repeat.end_date, "ddd DD MMM YYYY")}
                  </div>
                )}
              </div>

              {!(repeat_booking != null && repeat_booking === true) && (
                <div
                  style={{
                    width: "150px",
                    height: "32px",
                    marginTop: "6px",
                    marginRight: "6px",
                    marginBottom: "4px",
                    padding: "16px 4px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#FFFFFF",
                    border: "2px solid #842234",
                  }}>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#842234",
                    }}>
                    {selected_slot ?? "---"}
                  </div>
                </div>
              )}

              {repeat_booking != null && repeat_booking === true && (
                <div
                  style={{
                    width: "150px",
                    height: "32px",
                    marginTop: "6px",
                    marginRight: "6px",
                    marginBottom: "4px",
                    padding: "16px 4px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#FFFFFF",
                    border: "2px solid #842234",
                  }}>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#842234",
                    }}>
                    {convertTo12HourFormat(repeat.from)} - {convertTo12HourFormat(repeat.to)}{" "}
                  </div>
                </div>
              )}
              {repeat_booking != null && repeat_booking === true && (
                <div
                  className="mt-3 d-flex align-items-center justify-content-start"
                  style={{
                    width: "100%",
                    borderRadius: "12px",
                    padding: "12px 16px",
                    background: "#FFECF0",
                  }}>
                  <RepeatIcon /> <span className="mx-2">{repeatSentence()}</span>
                </div>
              )}
            </div>
          )}
          {!isProceed && (
            <div
              style={{
                padding: "16px",
                marginTop: "16px",
                borderRadius: "24px",
                background: "#ffffff",
              }}>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#1E1E1E",
                }}>
                Meeting details
              </div>
              <Form>
                <Form.Group controlId="titleInput">
                  <Form.Label
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#1E1E1E",
                    }}>
                    Meeting Title <span style={{ color: "#ff0000" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="text"
                    placeholder="Enter here..."
                    value={titleInputValue}
                    onChange={(event) => {
                      setTitleInputValue(event.target.value); // Update state with input value
                    }}

                    /* style={{
                borderColor: "#842234", // Change border color
                outline: "none",
                boxShadow:"none"
              }} */
                  />
                  <Form.Text className="text-muted">{isShowError && titleInputValue === "" && <div style={{ color: "#ff0000" }}>Meeting title required</div>}</Form.Text>
                </Form.Group>
                <Form.Group controlId="companyNameInput" style={{ marginTop: "8px" }}>
                  <Form.Label
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#1E1E1E",
                    }}>
                    Company Name{" "}
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        color: "#1E1E1E",
                      }}>
                      (Optional)
                    </span>
                  </Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="text"
                    placeholder="Enter here..."
                    value={companyInputValue}
                    onChange={(event) => {
                      setCompanyInputValue(event.target.value); // Update state with input value
                    }}
                  />
                  <Form.Text className="text-muted"></Form.Text>
                </Form.Group>
                <Form.Group controlId="companyNameInput" style={{ marginTop: "8px" }}>
                  <Form.Label
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#1E1E1E",
                    }}>
                    Description{" "}
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        color: "#1E1E1E",
                      }}>
                      (Optional)
                    </span>
                  </Form.Label>
                  <Form.Control
                    className="custom-input"
                    as="textarea"
                    rows={4}
                    placeholder="Enter here..."
                    value={descriptionInputValue}
                    onChange={(event) => {
                      setDescriptionInputValue(event.target.value); // Update state with input value
                    }}
                    multiple={true}
                  />
                  <Form.Text className="text-muted"></Form.Text>
                </Form.Group>

                <div xs={12} style={{ display: "flex" }}>
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="w-50 mt-3"
                    style={{
                      cursor: "pointer",
                      height: "36px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#ffffff",
                      border: "1px solid #E5E5E5",
                    }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}>
                      <BackIcon />
                      &nbsp;Back
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      if (titleInputValue !== "") {
                        setShowError(false);
                        setProceed(true);
                      } else {
                        setShowError(true);
                      }
                    }}
                    className="w-50 mt-3"
                    style={{
                      cursor: "pointer",
                      height: "36px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#842234",
                    }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#F3F6F9",
                      }}>
                      Proceed
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
          &nbsp;&nbsp;
          {isProceed && !isConfirmBooking && (
            <div className="mb-4 mt-3 px-3 py-3" style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}>
              <div
                style={{
                  fontWeight: "800",
                  fontSize: "20px",
                  color: "#1E1E1E",
                }}
                className="mb-2">
                Add reminders
              </div>

              <div
                style={{
                  width: "100%",
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "#1E1E1E",
                }}>
                {/* <select style={{ width: '100%', borderRadius: '12px', border: '1px solid #E5E5E5', backgroundImage: "url('../../assets/svg/bells.svg')", }} className="px-2 py-2">
              <option>Remind before 5 mins</option>
            </select> */}
                <div style={{ position: "relative", width: "100%" }}>
                  <img
                    src={bells}
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  {/* <select multiple style={{width: "100%",padding: "8px 8px 8px 32px",borderRadius: "12px",border: "1px solid #E5E5E5"}}>   
                <option>Remind me before 5 minutes</option>
                <option>Remind me before 10 minutes</option>
                <option>Remind me before 20 minutes</option>
                <option>Remind me before 20 minutes</option>
                <option>Remind me before 1 hour</option>
                <option>Remind me before 2 hours</option>
              </select> */}
                  <Select
                    style={{
                      width: "100%",
                      padding: "8px 8px 8px 32px",
                      borderRadius: "12px",
                      border: "1px solid #E5E5E5",
                    }}
                    options={remainderOptions}
                    isMulti
                    value={selectedRemainderOptions}
                    onChange={setSelectedRemainderOptions}
                  />
                </div>
              </div>
            </div>
          )}
          {isProceed && !isConfirmBooking && (
            <div
              style={{
                padding: "16px",
                borderRadius: "24px",
                background: "#ffffff",
              }}>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#1E1E1E",
                }}>
                Send Email Invites?
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#8790A1",
                }}>
                An email invite will be sent to your guests
              </div>
              <Form>
                {/*  <Form.Group controlId="companyNameInput" style={{ marginTop: '8px' }}>
              <Form.Label style={{ fontSize: "14px", fontWeight: "400", color: '#1E1E1E' }}>Email Address </Form.Label>
              <InputGroup>
                <Form.Control
                  className="custom-input"
                  type="text"
                  placeholder="Enter here..."
                  value={emailInputValue}
                  onChange={(event) => {
                    setEmailInputValue(event.target.value); // Update state with input value
                  }}
                />
                <InputGroup.Text >
                  <div onClick={() => {
                    if (emailInputValue !== '') {
                      const index = inviteEmails
                        .findIndex(element => element === emailInputValue);
                      if (index === -1) {
                        setInviteEmail((prevEmails) => {
                          prevEmails.push(emailInputValue);
                          setEmailInputValue('');
                          return prevEmails;
                        });
                      }
                    }
                  }} style={{ cursor: "pointer", height: '36px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '8px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#842234' }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: '#F3F6F9' }}>Add</div>
                  </div>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group> */}
                {/*  <div style={{display: 'flex',alignItems: 'center', justifyContent:'start',marginTop:'16px' }}>
                                     <div style={{ paddingLeft:'4px',fontSize:"14px", fontWeight:"700", color: '#1E1E1E' }}>Available features</div>
                                     </div> */}
                <div style={{ height: "40px", marginTop: "8px" }}>
                  {/* Input with Icon */}
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "center",
                      border: "0.7px solid #E5E5E5",
                      borderRadius: "8px",
                      paddingRight: "4px",
                    }}>
                    {/* <Form.Control
                       
                        type="text"
                        placeholder="Type here..."
                       className="feature-input"
                        value={availableFeatureValue}
                        onChange={(event) => {
                          setAvailableFeatureValue(event.target.value); // Update state with input value
                        }}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            handleFeatureAdd()
                         } }}
                      /> */}
                    <div className="w-100">
                      {/* <SearchWithAPI  className="w-100" border={false} onDropdownChange={handleEmailDropdownChange} apiUrl={apiUrl+`get_booking_emails`} placeholder={"Search email..."} selectedValue={emailOption!==null? emailOption.label:''} selectedOption={emailOption}/> */}
                      <SearchWithFreeTextAPI onDropdownChange={handleEmailDropdownChange} onChangeSearch={handleEmailOnChange} apiUrl={apiUrl + `get_booking_emails`} searchLimit={0} placeholder={"Search email..."} selectedValue={emailSearch} />
                    </div>
                    <div
                      onClick={() => {
                        setEmailErrorMsg("");
                        if (emailSearch !== null && emailSearch !== "") {
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (emailRegex.test(emailSearch)) {
                            const index = inviteEmails.findIndex((element) => element === emailSearch);
                            if (index === -1) {
                              setInviteEmail((prevEmails) => [...prevEmails, emailSearch]);
                              setEmailSearch("");
                            } else {
                              setEmailErrorMsg("Already exists");
                            }
                          } else {
                            setEmailErrorMsg("Please enter valid email");
                          }
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        width: "73px",
                        height: "31px",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#842234",
                      }}>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#F3F6F9",
                        }}>
                        Add
                      </div>
                    </div>
                  </div>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                    }}>
                    {emailErrorMsg}
                  </span>
                </div>
                &nbsp;
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#842234",
                  }}>
                  Added guests : {inviteEmails.length + 1}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  <div
                    style={{
                      height: "36px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      borderRadius: "8px",
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      backgroundColor: "#F5F7F9",
                    }}>
                    <label
                      style={{
                        fontSize: "13.5px",
                        fontWeight: "500",
                        color: "#1E1E1E",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}>
                      {email}
                    </label>
                  </div>

                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {inviteEmails.map((item, emailIndex) => (
                      <div
                        key={`${emailIndex}-email`}
                        style={{
                          height: "36px",
                          marginLeft: "8px",
                          marginRight: "8px",
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          borderRadius: "8px",
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                          backgroundColor: "#F5F7F9",
                        }}>
                        <label
                          style={{
                            fontSize: "13.5px",
                            fontWeight: "500",
                            color: "#1E1E1E",
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                          }}>
                          {item}
                        </label>
                        &nbsp;
                        <SlotCloseIcon
                          onClick={() => {
                            const updatedItems = [...inviteEmails];
                            updatedItems.splice(emailIndex, 1);
                            setInviteEmail(updatedItems);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div xs={12} style={{ display: "flex" }}>
                  <div
                    onClick={() => {
                      setProceed(false);
                    }}
                    className="w-50 mt-3"
                    style={{
                      cursor: "pointer",
                      height: "36px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#ffffff",
                      border: "1px solid #E5E5E5",
                    }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}>
                      <BackIcon />
                      &nbsp;Back
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      if (repeat_booking === true) {
                        repeatRoomBooking();
                      } else {
                        submitBookingRoom();
                      }
                    }}
                    className="w-50 mt-3"
                    style={{
                      cursor: "pointer",
                      height: "36px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#842234",
                    }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#F3F6F9",
                      }}>
                      Invite & Confirm Booking
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
          &nbsp;&nbsp;
          {isProceed && isConfirmBooking && (
            <div
              style={{
                padding: "16px",
                marginTop: "16px",
                borderRadius: "24px",
                height: "434px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#ffffff",
              }}>
              <div style={{ textAlign: "center" }}>
                <SuccessIcon />
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#1E1E1E",
                    placeItems: "center",
                  }}>
                  Congratulations !
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#8790A1",
                  }}>
                  Booking Successfully Completed.
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#8790A1",
                  }}>
                  Guest will receive respective emails accordingly.
                </div>
                &nbsp;
                <div style={{ textAlign: "center" }}>
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{
                      cursor: "pointer",
                      height: "36px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#842234",
                    }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#F3F6F9",
                      }}>
                      Okay, done
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <LoaderModal show={loading} />
    </Container>
  );
}
